import { createSelector } from 'reselect';
import { closeModalOpen } from './closeModalReducer';
import { RootState } from '..';

export const getCloseModalState = (state: RootState) => state.closeModal;

export const getCloseModalIsOpen = createSelector(getCloseModalState, closeModalOpen);
